import { render, staticRenderFns } from "./BlogCategoryPosts.vue?vue&type=template&id=54aee166"
import script from "./BlogCategoryPosts.vue?vue&type=script&lang=js"
export * from "./BlogCategoryPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports